import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '../components/Button';

/** Shown when a new app version is downloaded. The user chooses when to reload. */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div className="fixed inset-x-4 bottom-[calc(5.5rem+env(safe-area-inset-bottom))] z-50 mx-auto flex max-w-md items-center gap-3 rounded-xl border border-clinical-line bg-clinical-card p-3 shadow-xl md:bottom-6">
      <p className="flex-1 text-sm">A new version of RenalFlow is ready.</p>
      <Button variant="ghost" onClick={() => setNeedRefresh(false)}>
        Later
      </Button>
      <Button onClick={() => void updateServiceWorker(true)}>Update</Button>
    </div>
  );
}
